import type { RootState } from '../types';

export const selectLanguage = (state: RootState) => state.language;
export const selectCurrentLanguage = (state: RootState) => state.language.currentLanguage;
export const selectDirection = (state: RootState) => state.language.direction;
export const selectTourLanguage = (state: RootState) => state.language.tourLanguage;
export const selectAppLanguages = (state: RootState) => state.language.appLanguages;

export const selectAppSettings = (state: RootState) => state.appSettings;
export const selectLayout = (state: RootState) => state.appSettings?.layout ?? 'default';
export const selectAccessLevel = (state: RootState) => state.appSettings?.accessLevel ?? 'public';
export const selectAppLogo = (state: RootState) => state.appSettings?.appLogo;
export const selectNextUrl = (state: RootState) => state.appSettings?.nextUrl;
export const selectIdentification = (state: RootState) => state.appSettings?.identification;
export const selectShowNavigate = (state: RootState) => state.appSettings?.showNavigate ?? false;
export const selectAppName = (state: RootState) => state.appSettings?.name;
export const selectTerminology = (state: RootState) => state.appSettings?.terminology;

export const selectTreeLevel = (state: RootState) => state.treeLevel;
export const selectMainPlace = (state: RootState) => state.treeLevel.mainPlace;
export const selectChildrenIds = (state: RootState) => state.treeLevel.childrenIds;
export const selectCurrentTitle = (state: RootState) => state.treeLevel.currentTitle;
export const selectCurrentLayout = (state: RootState) => state.treeLevel.currentLayout;

export const selectModal = (state: RootState) => state.modal;
export const selectActiveModal = (state: RootState) => state.modal.activeModal;
export const selectModalPosition = (state: RootState) => state.modal.position;
export const selectModalData = (state: RootState) => state.modal.data;

export const selectMap = (state: RootState) => state.map;
export const selectMapCoordinates = (state: RootState) => state.map.coordinates;
export const selectMapProperties = (state: RootState) => state.map.properties;
export const selectMapDisplay = (state: RootState) => state.map.display;
